<template id="copy-to-clipboard">
    <div class="copy-to-clipboard__container">
        <div class="copy-to-clipboard__controls">
            <input v-show="!hideInput" class="copy-to-clipboard__input" type="text" v-model="message">
            <button class="copy-to-clipboard__button btn btn-primary btn-lg" type="button"
                    v-clipboard:copy="message"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
                <font-awesome-icon v-if="showCopyIcon" icon="copy" class="mr-2"></font-awesome-icon>
                <font-awesome-icon v-if="showSuccessIcon" icon="check" class="mr-2"></font-awesome-icon>
                <b>{{this.buttonMsg}}</b>
            </button>
        </div>
        <div v-show="showSuccessIcon && !errorText" class="copy-to-clipboard__message alert alert-success" role="alert">
            <b>Huzzah!</b> {{this.successText}}
        </div>
        <div v-if="errorText" class="copy-to-clipboard__message alert alert-danger copied-error" role="alert">
            <b>Oops!</b> {{this.errorText}}
        </div>
    </div>
</template>
<script>
    import {COPY_TO_CLIPBOARD_DATA_COPIED, COPY_TO_CLIPBOARD_FORCE_RESET_DATA} from '../events';
    /**
     * Usage Examples:
     *
     *  <copy-to-clipboard
     *      success-text="Now send that link to your guild administrator."
     *      button-text="Copy Shareable Link"
     *      msg-to-copy="{{ url('?utm_source=guild-setup-page&utm_medium=website&utm_campaign=ref-admin&utm_term=' . base64_encode($guild->name)) }}">
     *  </copy-to-clipboard>
     *
     */
    export default {
        props: {
            // Used to give context to the events that this component emits.
            ctc_id: {
              type: Number,
              default: 1,
            },
            msgToCopy: {
                type: String,
                required: true
            },
            buttonText: {
                type: String,
                required: true
            },
            buttonSuccessText: {
                type: String,
                default: 'Link Copied!'
            },
            successText: {
                type: String,
                required: true
            },
            errorText: {
                type: String,
                required: false
            },
            hideInput: {
                type: Boolean,
            },
        },
        data: function () {
            return {
                message: this.msgToCopy,
                buttonMsg: this.buttonText,
                showSuccessIcon: false,
                showCopyIcon: true,
            }
        },
        mounted() {
            this.setupSelectors();
            this.$root.$on(COPY_TO_CLIPBOARD_FORCE_RESET_DATA, this.resetState);
        },
        watch: {
            msgToCopy() {
              this.message = this.msgToCopy;
            },

        },
        methods: {
            onCopy: function (e) {
                this.resetState();
                let self = this;
                setTimeout(function() {
                    self.triggerCopySuccessAnimation();
                    self.$root.$emit(COPY_TO_CLIPBOARD_DATA_COPIED, self.ctc_id, self.msgToCopy );
                }, 500);
            },
            onError: function (e) {
                alert('Failed to copy texts')
            },
            setupSelectors: function() {
                this.input = this.$el.querySelector('.copy-to-clipboard__input');
                this.button = this.$el.querySelector('.copy-to-clipboard__button');
                this.successMsg = this.$el.querySelector('.copy-to-clipboard__message');
            },
            resetState: function() {
                this.showSuccessIcon = false;
                this.showCopyIcon = true;
                this.input.classList.remove('input-success');
                this.button.classList.remove('btn-success');
                this.successMsg.classList.remove('copied-success');
                this.buttonMsg = this.buttonText;
            },
            triggerCopySuccessAnimation: function() {
                this.showSuccessIcon = true;
                this.showCopyIcon = false;
                this.input.classList.add('input-success');
                this.button.classList.add('btn-success');
                this.successMsg.classList.add('copied-success');
                this.buttonMsg = this.buttonSuccessText;
            }
        },
    }
</script>
